import { AssignmentDeclinedReason, SimplifiedUserRole } from '@platform/client/schemas';

/** The value the user selects from the first-screen status dropdown. */
export enum DiscoveryStatus {
  Matched = 'matched',
  NotAGoodFit = 'not-a-good-fit',
  Scheduled = 'scheduled',
  StillDeciding = 'still-deciding',
  Unresponsive = 'unresponsive',
  MatchedElsewhere = 'matched-elsewhere',
  DifferentUpdate = 'different-update',
}

export enum DiscoveryCallModalStage {
  // Initial stage — the status dropdown
  Update_Selection = 'update-selection',

  // "It's a match" path (pro names/dates the project; rep confirms on a single screen)
  Match_Confirming = 'match-confirming',
  Custom_Naming = 'custom-naming',
  Confirm_Match = 'confirm-match',
  Pro_Confirm_Match = 'pro-confirm-match',
  Match_Confirmed = 'match-confirmed',

  // "Not a good fit" path
  Match_Declining = 'match-declining',
  Match_Declined = 'match-declined',

  // Non-decision update paths. The scheduled / still-deciding / different-update statuses
  // collect their fields inline on Update_Selection, so they have no standalone stage.
  // Matched_Elsewhere is inline for reps but keeps a standalone page for pros.
  Matched_Elsewhere = 'matched-elsewhere',
  Unresponsive = 'unresponsive',
  Update_Confirmed = 'update-confirmed',
}

export type DiscoveryModalDataProps = {
  introductionId: number;
  assignmentDiscoveryId: number;
  otherPartyName: string;
  userType: SimplifiedUserRole;
  projectId?: number | null;
  projectName?: string | null;
};

export type DiscoveryModalProps = DiscoveryModalDataProps & {
  onClose: () => void;
};

export type UpdateDiscoveryCallFormData = {
  status: DiscoveryStatus | null;
  reason: AssignmentDeclinedReason | null;
  declineReasonDetails: string | null;
  requestedMatchingSupport: boolean;
  // Optional "+ Add a note" shared by the scheduled / still-deciding / matched-elsewhere /
  // unresponsive screens
  additionalDetails: string | null;
  // Required free text for the "I have a different update" screen
  otherUpdateDetails: string | null;
  projectName: string | null;
};
